export default "/images/vendor/@coreui/icons/svg/flag/cif-ht.svg?876b9def07daa5b030e039c623f3c8de";